import React from 'react';
import { MapPin, Mail, Phone, Clock, CalendarDays } from 'lucide-react';
export function Footer() {
  return <footer id="footer" className="bg-[#225274] text-white pt-20 pb-10" data-id="element-133">
      <div className="max-w-7xl mx-auto px-4" data-id="element-134">
        <div className="grid md:grid-cols-3 gap-12 mb-16" data-id="element-135">
          {/* Brand & Intro */}
          <div className="space-y-6" data-id="element-136">
            <div className="flex items-center gap-3" data-id="element-137">
              <img src="https://cdn.magicpatterns.com/uploads/uTWzv2J5kt8GxQJy5fAuTB/pasted-image.png" alt="Colesville Dental Center Logo" className="h-12 w-auto brightness-0 invert" data-id="element-138" />
              <span className="text-2xl font-bold tracking-tight" data-id="element-139">
                COLESVILLE
              </span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed" data-id="element-140">
              Providing high-quality, pain-free, and personalized dental care.
              Your comfort and confidence in your smile are our top priorities.
            </p>
            <button onClick={() => window.location.href = '/book'} className="bg-gradient-to-r from-[#225274] via-[#4bafbc] to-[#54c595] hover:brightness-110 text-white px-6 py-3 rounded-full text-sm font-bold flex items-center gap-2 transition-all uppercase tracking-wider" data-id="element-141">
              <CalendarDays size={18} data-id="element-142" />
              BOOK AN APPOINTMENT
            </button>
          </div>

          {/* Contact Information */}
          <div data-id="element-143">
            <h3 className="text-lg font-bold mb-6 flex items-center gap-2 text-[#54c595]" data-id="element-144">
              Get In Touch
            </h3>
            <div className="space-y-6" data-id="element-145">
              <div className="flex items-start gap-4" data-id="element-146">
                <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-147">
                  <Phone size={20} className="text-[#54c595]" data-id="element-148" />
                </div>
                <div data-id="element-149">
                  <p className="font-bold" data-id="element-150">Phone</p>
                  <a href="tel:301-205-0386" className="text-white/70 text-sm hover:text-white transition-colors" data-id="element-151">
                    301-205-0386
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-152">
                <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-153">
                  <Mail size={20} className="text-[#54c595]" data-id="element-154" />
                </div>
                <div data-id="element-155">
                  <p className="font-bold" data-id="element-156">Email</p>
                  <a href="mailto:dentallcentertc@gmail.com" className="text-white/70 text-sm hover:text-white transition-colors" data-id="element-157">
                    dentallcentertc@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-158">
                <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-159">
                  <MapPin size={20} className="text-[#54c595]" data-id="element-160" />
                </div>
                <div data-id="element-161">
                  <p className="font-bold" data-id="element-162">Location</p>
                  <p className="text-white/70 text-sm leading-relaxed" data-id="element-163">
                    8737 Colesville Road #301
                    <br data-id="element-164" />
                    Silver Spring, MD, 20910
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Operating Hours */}
          <div data-id="element-165">
            <h3 className="text-lg font-bold mb-6 flex items-center gap-2 text-[#54c595]" data-id="element-166">
              <Clock size={20} data-id="element-167" />
              Operating Hours
            </h3>
            <div className="bg-white/5 rounded-xl p-6 border border-white/10" data-id="element-168">
              <div className="space-y-4" data-id="element-169">
                <div className="flex justify-between items-center border-b border-white/10 pb-3" data-id="element-170">
                  <span className="text-white/70 text-sm" data-id="element-171">Monday</span>
                  <span className="font-bold text-sm" data-id="element-172">9:00 AM - 5:00 PM</span>
                </div>
                <div className="flex justify-between items-center border-b border-white/10 pb-3" data-id="element-173">
                  <span className="text-white/70 text-sm" data-id="element-174">Tue, Thu & Fri</span>
                  <span className="font-bold text-sm" data-id="element-175">2:00 PM - 7:00 PM</span>
                </div>
                <div className="flex justify-between items-center pb-1" data-id="element-176">
                  <span className="text-white/70 text-sm" data-id="element-177">Wednesday</span>
                  <span className="font-bold text-sm" data-id="element-178">9:00 AM - 2:00 PM</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-white/50 text-xs" data-id="element-179">
          <p data-id="element-180">
            © {new Date().getFullYear()} Colesville Dental Center. All Rights
            Reserved.
          </p>
          <div className="flex gap-6" data-id="element-181">
            <a href="#" className="hover:text-white transition-colors" data-id="element-182">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-183">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-184">
              Accessibility
            </a>
          </div>
        </div>
      </div>
    </footer>;
}